export const order = 6;
export const routes = {
  path: '/statisticalSummary',
  name: 'statisticalSummary',
  component: () => import('@/views/layout'),
  meta: {
    title: '统计汇总',
    guard: {
      role: ['Admin'],
      permission: ['upms:statisticalSummary'],
    },
  },
  children: [
    {
      path: 'departmental',
      name: 'departmental',
      meta: {
        title: '部门达标情况',
        guard: {
          role: ['Admin'],
          permission: ['upms:statisticalSummaryPage:departmental'],
        },
      },
      component: () => import('@/views/statisticalSummary/departmental'),
    },
    {
      path: 'personal',
      name: 'personal',
      meta: {
        title: '个人汇总统计',
        guard: {
          role: ['Admin'],
          permission: ['upms:statisticalSummaryPage:personal'],
        },
      },
      component: () => import('@/views/statisticalSummary/personal'),
    },
    {
      path: 'annually',
      name: 'annually',
      meta: {
        title: '年度统计',
        guard: {
          role: ['Admin'],
          permission: ['upms:statisticalSummaryPage:annually'],
        },
      },
      component: () => import('@/views/statisticalSummary/annually'),
    },
    {
      path: 'summary',
      name: 'summary',
      meta: {
        title: '学习录入汇总',
        guard: {
          role: ['Admin'],
          permission: ['upms:statisticalSummaryPage:summary'],
        },
      },
      component: () => import('@/views/statisticalSummary/summary'),
    },
  ],
};
export const perms = {
  departmental: [
    {
      title: '查看详情',
      permission: 'upms:statisticalSummaryPage:departmental:detail',
    },
    {
      title: '批量导出',
      permission: 'upms:statisticalSummaryPage:departmental:export',
    },
    {
      title: '查看',
      permission: 'upms:statisticalSummaryPage:departmental:personalDeatil',
    },
  ],
  personal: [
    {
      title: '导出',
      permission: 'upms:statisticalSummaryPage:personal:export',
    },
  ],
  annually: [
    {
      title: '导出',
      permission: 'upms:statisticalSummaryPage:annually:export',
    },
  ],
  summary: [
    {
      title: '批量下载附件',
      permission: 'upms:statisticalSummaryPage:summary:someDownload',
    },
    { title: '导出', permission: 'upms:statisticalSummaryPage:summary:export' },
  ],
};
